import Moment from 'moment'
import 'moment-timezone'
import { extendMoment } from 'moment-range';

const Plugin = {}

Plugin.install = function install (Vue) {
  const moment = extendMoment(Moment)
  Vue.prototype.$timezone = moment.tz.guess()
  Vue.prototype.$currentTime = () => (moment().tz('Europe/London'))
  Vue.prototype.$moment = moment
}

export default Plugin

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Plugin)
}
